// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-page.staff-profiles-page {
  max-width: 880px;
  padding-top: 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 8px;
}
.business-page.staff-profiles-page > * {
  grid-column: 1/-1;
  min-width: 0;
}
.business-page.staff-profiles-page .business-back {
  grid-row: 1;
  margin-bottom: 6px;
  font-size: 12px;
  line-height: 18px;
}
.business-page.staff-profiles-page > h1 {
  grid-column: 1;
  grid-row: 2;
  align-self: center;
  margin: 0 0 10px;
  font-size: clamp(22px, 4vw, 26px);
  letter-spacing: -0.03em;
}
.business-page.staff-profiles-page .business-subtitle {
  display: none;
}
.business-page.staff-profiles-page .staff-profile-toolbar {
  grid-column: 2;
  grid-row: 2;
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}
.business-page.staff-profiles-page .staff-profile-toolbar .business-primary {
  gap: 6px;
  padding: 8px 12px;
  font-size: 13px;
  white-space: nowrap;
}
.business-page.staff-profiles-page .staff-profile-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border: 1px solid #e3e7ef;
  border-radius: 11px;
  padding: 0;
  background: #fff;
  color: #637089;
}
.business-page.staff-profiles-page .staff-profile-search {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.business-page.staff-profiles-page .staff-profile-search > svg {
  position: absolute;
  left: 13px;
  color: #8892a7;
  pointer-events: none;
}
.business-page.staff-profiles-page .staff-profile-search input {
  width: 100%;
  min-height: 44px;
  font-size: 16px;
  padding: 10px 46px 10px 42px;
  border-radius: 12px;
}
.business-page.staff-profiles-page .staff-profile-search input::-webkit-search-cancel-button {
  display: none;
}
.business-page.staff-profiles-page .staff-profile-search button {
  position: absolute;
  right: 0;
  border: none;
  background: none;
}
.business-page.staff-profiles-page .staff-profile-list {
  border: 1px solid #e1e6ef;
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
}
.business-page.staff-profiles-page .staff-profile-list-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 12px;
}
.business-page.staff-profiles-page .staff-profile-list-heading h2 {
  margin: 0;
  font-size: 13px;
}
.business-page.staff-profiles-page .staff-profile-list-heading > span {
  font-size: 12px;
  color: #7c879b;
  font-variant-numeric: tabular-nums;
}
.business-page.staff-profiles-page .staff-profile-row {
  width: 100%;
  min-height: 64px;
  border: 0;
  border-top: 1px solid #edf0f5;
  padding: 8px 12px;
  background: #fff;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #232137;
}
.business-page.staff-profiles-page .staff-profile-row:hover {
  background: #fafbfe;
}
.business-page.staff-profiles-page .staff-profile-row:focus-visible {
  outline-offset: -3px;
}
.business-page.staff-profiles-page .staff-profile-avatar {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 650;
  background: #eef0fb;
  color: #6a639d;
}
.business-page.staff-profiles-page .staff-profile-avatar[data-tone="1"] {
  color: #487e70;
  background: #ecf5f1;
}
.business-page.staff-profiles-page .staff-profile-avatar[data-tone="2"] {
  color: #a35c6d;
  background: #fff0f3;
}
.business-page.staff-profiles-page .staff-profile-row-info {
  min-width: 0;
  flex: 1 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 4px;
}
.business-page.staff-profiles-page .staff-profile-row-heading {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.business-page.staff-profiles-page .staff-profile-row-heading strong {
  font-size: 14px;
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.business-page.staff-profiles-page .staff-profile-grade {
  flex-shrink: 0;
  border-radius: 5px;
  padding: 2px 5px;
  color: #778296;
  background: #f1f3f8;
  font-size: 10px;
  white-space: nowrap;
}
.business-page.staff-profiles-page .staff-profile-grade.top_master {
  color: #8f6d27;
  background: #fff6e4;
}
.business-page.staff-profiles-page .staff-profile-row-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  white-space: nowrap;
  font-size: 12px;
  color: #78849a;
  line-height: 1.4;
}
.business-page.staff-profiles-page .staff-profile-row-meta > span:first-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
}
.business-page.staff-profiles-page .staff-profile-status {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
}
.business-page.staff-profiles-page .staff-profile-status::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #a0a9b8;
}
.business-page.staff-profiles-page .staff-profile-status.online {
  color: #428367;
}
.business-page.staff-profiles-page .staff-profile-status.online::before {
  background: #4b9474;
}
.business-page.staff-profiles-page .staff-profile-edit-icon {
  color: #7b879c;
  display: flex;
  flex: 0 0 16px;
}
.business-page.staff-profiles-page .staff-profile-edit-icon svg {
  width: 16px;
  height: 16px;
}
.business-page.staff-profiles-page .staff-profile-empty {
  padding: 18px 16px;
  border-top: 1px solid #edf0f5;
  text-align: center;
}
.business-page.staff-profiles-page .staff-profile-empty strong {
  font-size: 15px;
}
.business-page.staff-profiles-page .staff-profile-empty p {
  font-size: 13px;
  line-height: 1.5;
  color: #78849a;
  margin: 8px 0 12px;
}
.business-page.staff-profiles-page .staff-profile-empty .business-secondary {
  font-size: 13px;
}
.business-page.staff-profiles-page .staff-profile-notice, .business-page.staff-profiles-page .staff-profile-error {
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 8px;
}
.business-page.staff-profiles-page .staff-profile-notice {
  color: #32775b;
  background: #edf7f1;
}
.business-page.staff-profiles-page .staff-profile-error {
  color: #a71b34;
  background: #fff0f2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.business-page.staff-profiles-page .staff-profile-editor {
  max-width: 680px;
  border: 1px solid #e1e6ef;
  border-radius: 16px;
  background: #fff;
  overflow: visible;
}
.business-page.staff-profiles-page .staff-profile-editor-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #edf0f5;
}
.business-page.staff-profiles-page .staff-profile-editor-heading h2 {
  font-size: 15px;
  margin: 0 0 2px;
  scroll-margin-top: 110px;
}
.business-page.staff-profiles-page .staff-profile-editor-heading p {
  font-size: 12px;
  line-height: 1.4;
  color: #78849a;
  margin: 0;
  overflow-wrap: anywhere;
}
.business-page.staff-profiles-page .staff-profile-editor-heading > div {
  min-width: 0;
}
.business-page.staff-profiles-page .staff-profile-editor > .staff-profile-error {
  margin: 14px;
}
.business-page.staff-profiles-page .staff-profile-loading {
  padding: 14px;
  font-size: 13px;
  color: #78849a;
}
.business-page.staff-profiles-page .staff-profile-fieldset {
  border: none;
  padding: 0;
  margin: 0;
  min-width: 0;
}
.business-page.staff-profiles-page .staff-profile-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 12px;
}
.business-page.staff-profiles-page .staff-profile-fields label {
  min-width: 0;
}
.business-page.staff-profiles-page .staff-profile-form label {
  font-size: 12px;
  gap: 4px;
}
.business-page.staff-profiles-page .staff-profile-form input:not([type=checkbox]), .business-page.staff-profiles-page .staff-profile-form select, .business-page.staff-profiles-page .staff-profile-form textarea {
  box-sizing: border-box;
  width: 100%;
  font-size: 16px;
  min-height: 44px;
  padding: 9px 10px;
  border-radius: 10px;
  background: #fafbfe;
  color: #232137;
  scroll-margin-top: 100px;
  scroll-margin-bottom: 170px;
}
.business-page.staff-profiles-page .staff-profile-form textarea {
  min-height: 66px;
  line-height: 1.4;
  resize: vertical;
}
.business-page.staff-profiles-page .staff-profile-form input:focus, .business-page.staff-profiles-page .staff-profile-form select:focus, .business-page.staff-profiles-page .staff-profile-form textarea:focus {
  outline: 2px solid rgba(231, 47, 68, 0.1882352941);
  border-color: #e72f44;
  background: #fff;
}
.business-page.staff-profiles-page .staff-profile-form small {
  font-size: 11px;
  line-height: 1.4;
}
.business-page.staff-profiles-page .staff-profile-wide {
  grid-column: 1/-1;
}
.business-page.staff-profiles-page .staff-profile-form .staff-profile-field-caption {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.business-page.staff-profiles-page .staff-profile-pin {
  display: grid;
  gap: 4px;
}
.business-page.staff-profiles-page .staff-profile-pin-input {
  position: relative;
}
.business-page.staff-profiles-page .staff-profile-pin-input input {
  padding-right: 48px !important;
  letter-spacing: 0.16em;
}
.business-page.staff-profiles-page .staff-profile-pin-input button {
  position: absolute;
  right: 0;
  top: 0;
  background: none;
  border: none;
}
.business-page.staff-profiles-page .staff-profile-switch {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 48px;
  padding: 6px 12px;
  border-top: 1px solid #edf0f5;
  box-sizing: border-box;
  cursor: pointer;
}
.business-page.staff-profiles-page .staff-profile-switch > span {
  display: grid;
  gap: 2px;
}
.business-page.staff-profiles-page .staff-profile-switch strong {
  font-size: 13px;
  font-weight: 550;
}
.business-page.staff-profiles-page .staff-profile-switch input {
  appearance: none;
  position: relative;
  flex: 0 0 38px;
  width: 38px;
  height: 22px;
  min-height: 0;
  padding: 0;
  border: 0;
  border-radius: 20px;
  background: #c7cfdd;
  cursor: pointer;
}
.business-page.staff-profiles-page .staff-profile-switch input::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(35, 33, 55, 0.1254901961);
}
.business-page.staff-profiles-page .staff-profile-switch input:checked {
  background: #4b9474;
}
.business-page.staff-profiles-page .staff-profile-switch input:checked::before {
  left: 18px;
}
.business-page.staff-profiles-page .staff-profile-switch.staff-profile-dismissal {
  padding: 0;
  border: 0;
  margin-bottom: 10px;
}
.business-page.staff-profiles-page .staff-profile-switch.staff-profile-dismissal input:checked {
  background: #cb6a78;
}
.business-page.staff-profiles-page .staff-profile-section {
  border-top: 1px solid #edf0f5;
}
.business-page.staff-profiles-page .staff-profile-section > summary {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 8px 12px;
  box-sizing: border-box;
  list-style: none;
  font-size: 13px;
  cursor: pointer;
}
.business-page.staff-profiles-page .staff-profile-section > summary::-webkit-details-marker {
  display: none;
}
.business-page.staff-profiles-page .staff-profile-section > summary small {
  margin-left: auto;
}
.business-page.staff-profiles-page .staff-profile-section > summary svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #78849a;
}
.business-page.staff-profiles-page .staff-profile-section[open] > summary svg {
  transform: rotate(180deg);
}
.business-page.staff-profiles-page .staff-profile-section > div {
  padding: 0 12px 12px;
}
.business-page.staff-profiles-page .staff-profile-section .staff-profile-dismissed {
  color: #b26071;
}
.business-page.staff-profiles-page .staff-profile-actions {
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  border-top: 1px solid #edf0f5;
  background: #fff;
  border-radius: 0 0 16px 16px;
  position: sticky;
  bottom: 12px;
  z-index: 4;
}
.business-page.staff-profiles-page .staff-profile-actions button {
  min-height: 44px;
  font-size: 14px;
  padding: 8px 12px;
}
.business-page.staff-profiles-page .staff-profile-actions .business-primary {
  flex: 1 1;
}
@media (max-width: 1099px) {
  .business-page.staff-profiles-page .staff-profile-actions {
    bottom: calc(66px + env(safe-area-inset-bottom, 0px));
  }
}
@media (max-width: 650px) {
  .business-page.staff-profiles-page {
    padding: 10px 10px 20px;
  }
  .business-page.staff-profiles-page .staff-profile-add-detail {
    display: none;
  }
  .business-page.staff-profiles-page .staff-profile-row {
    padding-inline: 10px;
  }
  .business-page.staff-profiles-page .staff-profile-row-meta {
    font-size: 11px;
  }
  .business-page.staff-profiles-page .staff-profile-fields {
    padding: 10px;
    gap: 6px 8px;
  }
  .business-page.staff-profiles-page .staff-profile-main-field {
    grid-column: 1/-1;
    display: grid;
    grid-template-columns: 70px minmax(0, 1fr);
    gap: 8px;
    align-items: center;
  }
  .business-page.staff-profiles-page .staff-profile-form .staff-profile-main-field .staff-profile-field-caption,
  .business-page.staff-profiles-page .staff-profile-form .staff-profile-pin > .staff-profile-field-caption {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 2px;
  }
  .business-page.staff-profiles-page .staff-profile-pin {
    grid-template-columns: 70px minmax(0, 1fr);
    gap: 8px;
    align-items: center;
  }
}

.lkfr-app .business-page.staff-profiles-page {
  max-width: 880px;
  margin-inline: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/StaffProfilesPage/staffProfiles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,0CAAA;EACA,eAAA;AACF;AAAE;EAAM,iBAAA;EAAqB,YAAA;AAI7B;AAHE;EAAiB,WAAA;EAAa,kBAAA;EAAoB,eAAA;EAAiB,iBAAA;AASrE;AARE;EAAO,cAAA;EAAgB,WAAA;EAAa,kBAAA;EAAoB,gBAAA;EAAkB,iCAAA;EAAmC,uBAAA;AAgB/G;AAfE;EAAqB,aAAA;AAkBvB;AAjBE;EAAyB,cAAA;EAAgB,WAAA;EAAa,aAAA;EAAe,QAAA;EAAU,mBAAA;AAwBjF;AAxBsG;EAAoB,QAAA;EAAU,iBAAA;EAAmB,eAAA;EAAiB,mBAAA;AA8BxK;AA7BE;EAA6B,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,yBAAA;EAA2B,mBAAA;EAAqB,UAAA;EAAY,gBAAA;EAAkB,cAAA;AA0C5N;AAzCE;EAAwB,kBAAA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,kBAAA;AA+ClF;AA9CI;EAAQ,kBAAA;EAAoB,UAAA;EAAY,cAAA;EAAgB,oBAAA;AAoD5D;AAnDI;EAAQ,WAAA;EAAa,gBAAA;EAAkB,eAAA;EAAiB,4BAAA;EAA8B,mBAAA;AA0D1F;AA1D+G;EAAkC,aAAA;AA6DjJ;AA5DI;EAAS,kBAAA;EAAoB,QAAA;EAAU,YAAA;EAAc,gBAAA;AAkEzD;AAhEE;EAAsB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,gBAAA;AAsE1F;AArEE;EAA8B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,iBAAA;AA4E/G;AA5EkI;EAAK,SAAA;EAAW,eAAA;AAgFlJ;AAhFqK;EAAS,eAAA;EAAiB,cAAA;EAAgB,kCAAA;AAqF/M;AApFE;EAAqB,WAAA;EAAa,gBAAA;EAAkB,SAAA;EAAW,6BAAA;EAA+B,iBAAA;EAAmB,gBAAA;EAAkB,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,cAAA;AAiGrM;AAhGI;EAAU,mBAAA;AAmGd;AAnGqC;EAAkB,oBAAA;AAsGvD;AApGE;EAAwB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;EAAqB,cAAA;AAgHtL;AA/GI;EAAmB,cAAA;EAAgB,mBAAA;AAmHvC;AAnH8D;EAAmB,cAAA;EAAgB,mBAAA;AAuHjG;AArHE;EAA0B,YAAA;EAAc,SAAA;EAAS,aAAA;EAAe,qCAAA;EAAuC,QAAA;AA4HzG;AA3HE;EAA6B,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,QAAA;AAiIjF;AAjI2F;EAAS,eAAA;EAAiB,YAAA;EAAc,SAAA;EAAS,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAyIvL;AAxIE;EAAuB,cAAA;EAAgB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,mBAAA;EAAqB,eAAA;EAAiB,mBAAA;AAiJrI;AAjJ0J;EAAe,cAAA;EAAgB,mBAAA;AAqJzL;AApJE;EAA0B,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,YAAA;EAAc,mBAAA;EAAqB,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AA8J9I;AA9JgK;EAAqB,YAAA;EAAc,gBAAA;EAAkB,uBAAA;EAAyB,kCAAA;AAoK9O;AAnKE;EAAwB,cAAA;EAAgB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,eAAA;AA0K/F;AAzKI;EAAY,WAAA;EAAa,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,mBAAA;AAgL1E;AA/KI;EAAW,cAAA;AAkLf;AAlL+B;EAAY,mBAAA;AAqL3C;AAnLE;EAA2B,cAAA;EAAgB,aAAA;EAAe,cAAA;AAwL5D;AAxL4E;EAAM,WAAA;EAAa,YAAA;AA4L/F;AA3LE;EAAuB,kBAAA;EAAoB,6BAAA;EAA+B,kBAAA;AAgM5E;AAhMgG;EAAS,eAAA;AAmMzG;AAnM4H;EAAI,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,kBAAA;AAyMnL;AAzMyM;EAAsB,eAAA;AA4M/N;AA3ME;EAA8C,kBAAA;EAAoB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AAkN5H;AAjNE;EAAwB,cAAA;EAAgB,mBAAA;AAqN1C;AApNE;EAAuB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,uBAAA;EAAyB,SAAA;AA4N9H;AA3NE;EAAwB,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,iBAAA;AAkO9G;AAjOE;EAAgC,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,gCAAA;AAwOrG;AAxOuI;EAAK,eAAA;EAAiB,eAAA;EAAiB,wBAAA;AA6O9K;AA7O0M;EAAI,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,SAAA;EAAW,uBAAA;AAoP5Q;AApPuS;EAAQ,YAAA;AAuP/S;AAtPE;EAA+C,YAAA;AAyPjD;AAxPE;EAAyB,aAAA;EAAe,eAAA;EAAiB,cAAA;AA6P3D;AA5PE;EAA0B,YAAA;EAAc,UAAA;EAAY,SAAA;EAAW,YAAA;AAkQjE;AAjQE;EAAwB,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,aAAA;AAuQrG;AAtQI;EAAQ,YAAA;AAyQZ;AAtQI;EAAQ,eAAA;EAAiB,QAAA;AA0Q7B;AAzQI;EAA+C,sBAAA;EAAwB,WAAA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,iBAAA;EAAmB,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;EAAgB,wBAAA;EAA0B,2BAAA;AAqRlO;AApRI;EAAW,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;AAyRnD;AAxRI;EAA4C,kDAAA;EAA8B,qBAAA;EAAuB,gBAAA;AA6RrG;AA5RI;EAAQ,eAAA;EAAiB,gBAAA;AAgS7B;AA9RE;EAAsB,iBAAA;AAiSxB;AAhSE;EAAmD,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;AAuS9I;AAtSE;EAAqB,aAAA;EAAe,QAAA;AA0StC;AAzSE;EAA2B,kBAAA;AA4S7B;AA5SiD;EAAQ,8BAAA;EAAgC,sBAAA;AAgTzF;AAhTkH;EAAS,kBAAA;EAAoB,QAAA;EAAU,MAAA;EAAQ,gBAAA;EAAkB,YAAA;AAuTnL;AAtTE;EAAwB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,gBAAA;EAAkB,iBAAA;EAAmB,6BAAA;EAA+B,sBAAA;EAAwB,eAAA;AAkU1N;AAjUI;EAAS,aAAA;EAAe,QAAA;AAqU5B;AArUwC;EAAS,eAAA;EAAiB,gBAAA;AAyUlE;AAxUI;EAAQ,gBAAA;EAAkB,kBAAA;EAAoB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,aAAA;EAAe,UAAA;EAAY,SAAA;EAAW,mBAAA;EAAqB,mBAAA;EAAqB,eAAA;AAqV7K;AApVM;EAAY,WAAA;EAAa,kBAAA;EAAoB,QAAA;EAAU,SAAA;EAAW,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,gBAAA;EAAkB,oDAAA;AA+VzI;AA9VM;EAAY,mBAAA;AAiWlB;AAjWuC;EAAY,UAAA;AAoWnD;AAlWI;EAA4B,UAAA;EAAY,SAAA;EAAW,mBAAA;AAuWvD;AAvW4E;EAAgB,mBAAA;AA0W5F;AAxWE;EAAyB,6BAAA;AA2W3B;AA1WI;EAAY,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,gBAAA;EAAkB,iBAAA;EAAmB,sBAAA;EAAwB,gBAAA;EAAkB,eAAA;EAAiB,eAAA;AAqX/J;AApXM;EAA4B,aAAA;AAuXlC;AAvXmD;EAAQ,iBAAA;AA0X3D;AA1XgF;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,cAAA;AAgYjI;AA9XI;EAAwB,yBAAA;AAiY5B;AAhYI;EAAQ,oBAAA;AAmYZ;AAlYI;EAA2B,cAAA;AAqY/B;AAnYE;EAAyB,aAAA;EAAe,QAAA;EAAU,iBAAA;EAAmB,6BAAA;EAA+B,gBAAA;EAAkB,4BAAA;EAA8B,gBAAA;EAAkB,YAAA;EAAc,UAAA;AA8YtL;AA7YI;EAAS,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;AAkZhD;AAlZqE;EAAoB,SAAA;AAqZzF;AAnZE;EAA6B;IAAyB,qDAAA;EAuZtD;AACF;AAvZE;EACE;IAAI,uBAAA;EA0ZN;EAzZE;IAA4B,aAAA;EA4Z9B;EA3ZE;IAAqB,oBAAA;EA8ZvB;EA7ZE;IAA0B,eAAA;EAga5B;EA/ZE;IAAwB,aAAA;IAAe,YAAA;EAmazC;EAlaE;IAA4B,iBAAA;IAAqB,aAAA;IAAe,0CAAA;IAA4C,QAAA;IAAU,mBAAA;EAyaxH;EAxaE;;IACwE,sBAAA;IAAwB,uBAAA;IAAyB,uBAAA;IAAyB,QAAA;EA8apJ;EA7aE;IAAqB,0CAAA;IAA4C,QAAA;IAAU,mBAAA;EAkb7E;AACF;;AAhbA;EAA+C,gBAAA;EAAkB,mBAAA;AAqbjE","sourcesContent":[".business-page.staff-profiles-page {\n  max-width: 880px;\n  padding-top: 12px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  column-gap: 8px;\n  > * { grid-column: 1 / -1; min-width: 0; }\n  .business-back { grid-row: 1; margin-bottom: 6px; font-size: 12px; line-height: 18px; }\n  > h1 { grid-column: 1; grid-row: 2; align-self: center; margin: 0 0 10px; font-size: clamp(22px, 4vw, 26px); letter-spacing: -.03em; }\n  .business-subtitle { display: none; }\n  .staff-profile-toolbar { grid-column: 2; grid-row: 2; display: flex; gap: 6px; margin-bottom: 10px; .business-primary { gap: 6px; padding: 8px 12px; font-size: 13px; white-space: nowrap; } }\n  .staff-profile-icon-button { display: inline-flex; align-items: center; justify-content: center; width: 44px; height: 44px; flex: 0 0 44px; border: 1px solid #e3e7ef; border-radius: 11px; padding: 0; background: #fff; color: #637089; }\n  .staff-profile-search { position: relative; display: flex; align-items: center; margin-bottom: 8px;\n    > svg { position: absolute; left: 13px; color: #8892a7; pointer-events: none; }\n    input { width: 100%; min-height: 44px; font-size: 16px; padding: 10px 46px 10px 42px; border-radius: 12px; &::-webkit-search-cancel-button { display: none; } }\n    button { position: absolute; right: 0; border: none; background: none; }\n  }\n  .staff-profile-list { border: 1px solid #e1e6ef; border-radius: 14px; background: #fff; overflow: hidden; }\n  .staff-profile-list-heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 9px 12px; h2 { margin: 0; font-size: 13px; } > span { font-size: 12px; color: #7c879b; font-variant-numeric: tabular-nums; } }\n  .staff-profile-row { width: 100%; min-height: 64px; border: 0; border-top: 1px solid #edf0f5; padding: 8px 12px; background: #fff; text-align: left; display: flex; align-items: center; gap: 8px; color: #232137;\n    &:hover { background: #fafbfe; } &:focus-visible { outline-offset: -3px; }\n  }\n  .staff-profile-avatar { width: 32px; height: 32px; flex: 0 0 32px; display: grid; place-items: center; border-radius: 10px; font-size: 12px; font-weight: 650; background: #eef0fb; color: #6a639d;\n    &[data-tone=\"1\"] { color: #487e70; background: #ecf5f1; } &[data-tone=\"2\"] { color: #a35c6d; background: #fff0f3; }\n  }\n  .staff-profile-row-info { min-width: 0; flex: 1; display: grid; grid-template-columns: minmax(0, 1fr); gap: 4px; }\n  .staff-profile-row-heading { min-width: 0; display: flex; align-items: center; gap: 6px; strong { font-size: 14px; min-width: 0; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } }\n  .staff-profile-grade { flex-shrink: 0; border-radius: 5px; padding: 2px 5px; color: #778296; background: #f1f3f8; font-size: 10px; white-space: nowrap; &.top_master { color: #8f6d27; background: #fff6e4; } }\n  .staff-profile-row-meta { display: flex; align-items: center; gap: 8px; min-width: 0; white-space: nowrap; font-size: 12px; color: #78849a; line-height: 1.4; > span:first-child { min-width: 0; overflow: hidden; text-overflow: ellipsis; font-variant-numeric: tabular-nums; } }\n  .staff-profile-status { flex-shrink: 0; display: inline-flex; align-items: center; gap: 4px; font-size: 11px;\n    &::before { content: \"\"; width: 5px; height: 5px; border-radius: 50%; background: #a0a9b8; }\n    &.online { color: #428367; &::before { background: #4b9474; } }\n  }\n  .staff-profile-edit-icon { color: #7b879c; display: flex; flex: 0 0 16px; svg { width: 16px; height: 16px; } }\n  .staff-profile-empty { padding: 18px 16px; border-top: 1px solid #edf0f5; text-align: center; strong { font-size: 15px; } p { font-size: 13px; line-height: 1.5; color: #78849a; margin: 8px 0 12px; } .business-secondary { font-size: 13px; } }\n  .staff-profile-notice, .staff-profile-error { padding: 10px 12px; border-radius: 12px; font-size: 13px; line-height: 1.5; margin: 0 0 8px; }\n  .staff-profile-notice { color: #32775b; background: #edf7f1; }\n  .staff-profile-error { color: #a71b34; background: #fff0f2; display: flex; flex-direction: column; align-items: flex-start; gap: 10px; }\n  .staff-profile-editor { max-width: 680px; border: 1px solid #e1e6ef; border-radius: 16px; background: #fff; overflow: visible; }\n  .staff-profile-editor-heading { display: flex; align-items: center; gap: 10px; padding: 10px 12px; border-bottom: 1px solid #edf0f5; h2 { font-size: 15px; margin: 0 0 2px; scroll-margin-top: 110px; } p { font-size: 12px; line-height: 1.4; color: #78849a; margin: 0; overflow-wrap: anywhere; } > div { min-width: 0; } }\n  .staff-profile-editor > .staff-profile-error { margin: 14px; }\n  .staff-profile-loading { padding: 14px; font-size: 13px; color: #78849a; }\n  .staff-profile-fieldset { border: none; padding: 0; margin: 0; min-width: 0; }\n  .staff-profile-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; padding: 12px;\n    label { min-width: 0; }\n  }\n  .staff-profile-form {\n    label { font-size: 12px; gap: 4px; }\n    input:not([type=checkbox]), select, textarea { box-sizing: border-box; width: 100%; font-size: 16px; min-height: 44px; padding: 9px 10px; border-radius: 10px; background: #fafbfe; color: #232137; scroll-margin-top: 100px; scroll-margin-bottom: 170px; }\n    textarea { min-height: 66px; line-height: 1.4; resize: vertical; }\n    input:focus, select:focus, textarea:focus { outline: 2px solid #e72f4430; border-color: #e72f44; background: #fff; }\n    small { font-size: 11px; line-height: 1.4; }\n  }\n  .staff-profile-wide { grid-column: 1 / -1; }\n  .staff-profile-form .staff-profile-field-caption { display: flex; flex-direction: row; align-items: center; justify-content: space-between; gap: 8px; }\n  .staff-profile-pin { display: grid; gap: 4px; }\n  .staff-profile-pin-input { position: relative; input { padding-right: 48px !important; letter-spacing: .16em; } button { position: absolute; right: 0; top: 0; background: none; border: none; } }\n  .staff-profile-switch { display: flex; flex-direction: row; align-items: center; justify-content: space-between; gap: 10px; min-height: 48px; padding: 6px 12px; border-top: 1px solid #edf0f5; box-sizing: border-box; cursor: pointer;\n    > span { display: grid; gap: 2px; } strong { font-size: 13px; font-weight: 550; }\n    input { appearance: none; position: relative; flex: 0 0 38px; width: 38px; height: 22px; min-height: 0; padding: 0; border: 0; border-radius: 20px; background: #c7cfdd; cursor: pointer;\n      &::before { content: \"\"; position: absolute; top: 2px; left: 2px; width: 18px; height: 18px; border-radius: 50%; background: #fff; box-shadow: 0 1px 3px #23213720; }\n      &:checked { background: #4b9474; &::before { left: 18px; } }\n    }\n    &.staff-profile-dismissal { padding: 0; border: 0; margin-bottom: 10px; input:checked { background: #cb6a78; } }\n  }\n  .staff-profile-section { border-top: 1px solid #edf0f5;\n    > summary { display: flex; align-items: center; gap: 10px; min-height: 44px; padding: 8px 12px; box-sizing: border-box; list-style: none; font-size: 13px; cursor: pointer;\n      &::-webkit-details-marker { display: none; } small { margin-left: auto; } svg { width: 16px; height: 16px; flex-shrink: 0; color: #78849a; }\n    }\n    &[open] > summary svg { transform: rotate(180deg); }\n    > div { padding: 0 12px 12px; }\n    .staff-profile-dismissed { color: #b26071; }\n  }\n  .staff-profile-actions { display: flex; gap: 8px; padding: 8px 12px; border-top: 1px solid #edf0f5; background: #fff; border-radius: 0 0 16px 16px; position: sticky; bottom: 12px; z-index: 4;\n    button { min-height: 44px; font-size: 14px; padding: 8px 12px; } .business-primary { flex: 1; }\n  }\n  @media (max-width: 1099px) { .staff-profile-actions { bottom: calc(66px + env(safe-area-inset-bottom, 0px)); } }\n  @media (max-width: 650px) {\n    & { padding: 10px 10px 20px; }\n    .staff-profile-add-detail { display: none; }\n    .staff-profile-row { padding-inline: 10px; }\n    .staff-profile-row-meta { font-size: 11px; }\n    .staff-profile-fields { padding: 10px; gap: 6px 8px; }\n    .staff-profile-main-field { grid-column: 1 / -1; display: grid; grid-template-columns: 70px minmax(0, 1fr); gap: 8px; align-items: center; }\n    .staff-profile-form .staff-profile-main-field .staff-profile-field-caption,\n    .staff-profile-form .staff-profile-pin > .staff-profile-field-caption { flex-direction: column; align-items: flex-start; justify-content: center; gap: 2px; }\n    .staff-profile-pin { grid-template-columns: 70px minmax(0, 1fr); gap: 8px; align-items: center; }\n  }\n}\n.lkfr-app .business-page.staff-profiles-page { max-width: 880px; margin-inline: auto; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
